import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import logo2026 from '../img/2026/aldi-logo.png';
import Modal from "./Modal";
import Footer from "./Footer";

const Header = ({ isExpired, isHome }) => {
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname.replace(/\/+$/, '') || '/';
    const onResults = pathname === '/results';
    const onFestiveFaceOff = pathname.startsWith('/festive-face-off');

    const modalContent = (
        <>
            <main>
                <ul className="menu text-center">
                    <li>
                        <Link to="/" onClick={() => setShowModal(false)}>
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link to="/calendar" onClick={() => setShowModal(false)}>
                            Calendar
                        </Link>
                    </li>
                    <li>
                        <Link to="/results" onClick={() => setShowModal(false)}>
                            Results
                        </Link>
                    </li>
                </ul>
            </main>
            <Footer />
        </>
    )

    const handleBack = (e) => {
      e.preventDefault();
      navigate(-1);
    };

    return (
        <>
            <header className={`header text-center md:min-h-[82px] ${isHome ? 'md:mt-[42px]' : 'md:mt-[14px]'}`}>
                {isExpired ? (
                    <div className="container flex items-center justify-between py-8">
                        <Link to="/" className="mx-auto logo">
                            <img
                                src={logo2026}
                                alt="ALDI"
                                className="home-logo"
                            />
                        </Link>
                    </div>
                ) : (
                    <div className="relative container flex flex-wrap items-center justify-end py-6 md:pt-8 [&_span::before]:content-[''] [&_span::before]:block">
                        <Link onClick={(e) => handleBack(e)} className={`btn btn-header ${onFestiveFaceOff ? '' : 'hidden'}`}>
                            <span className='!bg-cover before:bg-back-icon before:bg-cover !p-[14px] !before:bg-no-repeat before:w-[24px] before:h-[24px] md:before:mr-[6px]'>
                                {onFestiveFaceOff && <span className='sr-only md:not-sr-only !bg-none !p-0'>Back</span>}
                            </span>
                        </Link>
                        {/* <Link to="/festive-face-off" className={`btn btn-header hidden ${onFestiveFaceOff ? 'hidden' : ''}`}>
                            <span className='min-w-[52px] min-h-[52px] !bg-cover !px-[14px] md:!px-5 before:bg-swords-icon before:bg-cover before:bg-no-repeat before:w-[19px] before:h-[19px] before:translate-y-px md:before:mr-[6px]'>
                                <span className='sr-only md:not-sr-only !bg-none !p-0'>Join your team!</span>
                            </span>
                        </Link> */}
                        <Link to="/" className={`mx-auto pl-[30px] logo md:pl-0 md:left-1/2 md:absolute md:[transform:translateX(-50%)]`}>
                            <img
                                src={logo2026}
                                alt="ALDI"
                                className="home-logo"
                            />
                        </Link>
                        <Link to={onResults ? '/calendar' : '/results'}
                            className={`btn btn-header ${onResults ? 'header-action-calendar' : 'header-action-winners'} ${onFestiveFaceOff ? 'invisible md:max-w-[100px]' : ''}`}
                            aria-label={onResults ? 'Open Calendar' : 'See Winners'}>

                            <span className= {`${onResults ? 'before:bg-calendar-icon before:w-[20px] before:h-[18px]' : 'before:bg-trophy-icon before:w-[21px] before:h-[21px]'}
                            md:min-w-[168px] !bg-cover !px-[14px] before:bg-cover before:bg-no-repeat md:before:mr-[6px] min-w-[52px] min-h-[52px]`}>

                            <span className='sr-only md:not-sr-only !bg-none !p-0'>{onResults ? "Calendar" : "Winners"}</span></span>
                        </Link>
                        {/* <Link to="/festive-face-off" className={`btn btn-header hidden mt-4 mb-2 mx-auto`}>
                            <span className='before:bg-swords-icon before:bg-cover before:bg-no-repeat before:w-[19px] before:h-[19px] before:translate-y-px before:mr-[6px]'>Join the fun!</span>
                        </Link> */}

                    </div>
                )}
            </header>
            <Modal
                showModal={showModal}
                setShowModal={setShowModal}
                classes={'modal-menu'}
                content={modalContent}
            />
        </>
    );
};

export default Header;
